// extracted by mini-css-extract-plugin
export var avatarContainer = "_8e-0";
export var avatarTypingWave = "_8e-i";
export var gray = "_8e-f";
export var green = "_8e-c";
export var icon = "_8e-9";
export var image = "_8e-1";
export var lg = "_8e-6";
export var md = "_8e-5";
export var presenceDot = "_8e-b";
export var red = "_8e-d";
export var sm = "_8e-4";
export var status = "_8e-a";
export var typingDot = "_8e-h";
export var typingPill = "_8e-g";
export var xl = "_8e-7";
export var xs = "_8e-3";
export var xxl = "_8e-8";
export var xxs = "_8e-2";
export var yellow = "_8e-e";